function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "darr",
  "data-name": "darr",
  transform: "translate(-1193 -264.034)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rechteck_1",
  "data-name": "Rechteck 1",
  width: 33,
  height: 30,
  transform: "translate(1193 264.034)",
  fill: "#2d6188"
}), /*#__PURE__*/React.createElement("path", {
  id: "Icon_awesome-arrow-down",
  "data-name": "Icon awesome-arrow-down",
  d: "M12.859,8.077l.679.679a.731.731,0,0,1,0,1.037L7.6,15.738a.731.731,0,0,1-1.037,0L.613,9.792a.731.731,0,0,1,0-1.037l.679-.679a.735.735,0,0,1,1.049.012l3.511,3.686V2.984a.732.732,0,0,1,.734-.734h.979a.732.732,0,0,1,.734.734v8.79L11.81,8.089A.73.73,0,0,1,12.859,8.077Z",
  transform: "translate(1202.715 269.608)",
  fill: "#fff"
}));

function SvgArrowDownHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 30,
    viewBox: "0 0 33 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownHover);
export default __webpack_public_path__ + "static/media/arrow_down_hover.5aab92ff4c73e000e6616c10bb4f2d8b.svg";
export { ForwardRef as ReactComponent };